import React from 'react';

import { WithStyles, withStyles, useMediaQuery } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { styles } from './ContractAdvice.style';

function ContractAdvice(props: WithStyles<typeof styles>) {
    const { classes } = props;
    const mobileStart = useMediaQuery('(max-width:749px)');

    return (
        <div>
            <Grid container className={classes.subGridTitle}>
                <Grid item xs={12}>
                    <Box className={classes.titleContainer}>
                        <p className={classes.title}>AVISO DE MODIFICACIÓN</p>
                        <p id="bot" className={classes.title}>
                            EN TU CONTRATO DE ADHESIÓN
                        </p>
                    </Box>

                    <Box className={classes.section}>
                        <p className={classes.text}>
                            <strong>Cuenta de Fondos de Pago Electrónico</strong>
                        </p>
                        <p className={classes.text}>
                            <strong>RECA NÚM: 15717-458-035582/05-02440-0925</strong>
                        </p>
                    </Box>
                    <Box className={classes.section}>
                        <p className={classes.text}>
                            En cumplimiento a lo establecido en las Disposiciones de Carácter General de la CONDUSEF en
                            materia de transparencia y sanas prácticas aplicables a las Instituciones de Tecnología
                            Financiera, te notificamos que{' '}
                            <strong>
                                en un plazo de 30 (treinta) días naturales posteriores a que recibas este aviso
                            </strong>
                            , entrarán en vigor las modificaciones realizadas a tu Contrato de Adhesión de Emisión y
                            Depósito Mercantil de Fondos de Pago Electrónico (el <strong>“Contrato”</strong>), celebrado
                            con Cuenca Tecnología Financiera, S.A. de C.V., Institución de Fondos de Pago Electrónico (
                            <strong>“Cuenca”</strong>).
                        </p>
                        <p className={classes.text}>
                            El contrato modificado se encuentra inscrito en el Registro de Contratos de Adhesión de la
                            CONDUSEF (“RECA”) bajo el número <strong>15717-458-035582/05-02440-0925</strong>,
                            reemplazando la versión anterior con número 15717-458-035582/03-01762-0724.
                        </p>
                    </Box>
                    <Box className={classes.section}>
                        <p className={classes.subtitle}>
                            <strong>Resumen de modificaciones:</strong>
                        </p>
                    </Box>
                </Grid>
            </Grid>

            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Definiciones y estructura</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>- Actualización y ampliación de definiciones.</p>
                    <p className={classes.text}>
                        - Se actualiza y se mejora el formato del Contrato para su mejor comprensión.
                    </p>
                    <p className={classes.text}>
                        - Se incorpora la referencia a los Términos y Condiciones de la Plataforma como parte integral
                        del Contrato.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Estados de Cuenta</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Consulta disponible dentro de los 5 (cinco) días hábiles posteriores al cierre mensual (antes
                        10 días naturales).
                    </p>
                    <p className={classes.text}>
                        - Disponibilidad de consulta limitada a los 2 (dos) meses inmediatos anteriores.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Cargos no reconocidos y objeciones</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Aclaración del proceso para presentar avisos por cargos no reconocidos y objeciones.
                    </p>
                    <p className={classes.text}>
                        - Proceso automatizado para la presentación de dichos avisos a través de la aplicación.
                    </p>
                    <p className={classes.text}>
                        - Cuenca debe otorgar un número de referencia a las 24 (veinticuatro) horas del aviso.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Comisiones</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - <strong>Manejo de Cuenta</strong>: $43.10 MXN + IVA mensual (sin cambios).
                    </p>
                    <p className={classes.text}>
                        - <strong>Transferencias</strong>:
                    </p>
                    <ul>
                        <li className={classes.text}>
                            Primeras 15 mensuales a cuentas externas: gratuitas (sin cambios).
                        </li>
                        <li className={classes.text}>
                            A partir de la transferencia número 16: $8.62 MXN + IVA cada una (sin cambios).
                        </li>
                        <li className={classes.text}>
                            <strong>Novedad: 1 transferencia gratuita diaria adicional.</strong>
                        </li>
                    </ul>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Bloqueo y Cierre de Cuentas</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Se regula de forma más detallada el procedimiento de cancelación de cuentas.
                    </p>
                    <p className={classes.text}>
                        - Se aclaran los efectos de la cancelación: suspensión inmediata de cobros, transferencias y
                        domiciliaciones.
                    </p>
                    <p className={classes.text}>
                        - Se aclara que el cierre de cuenta implica la terminación del Contrato.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Eliminación de tarjetas</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Se eliminan todas las disposiciones sobre entrega, uso, robo, extravío y bloqueo de las
                        tarjetas.
                    </p>
                    <p className={classes.text}>
                        - El Contrato ya no contempla tarjetas como medio de disposición de fondos.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Nivel de Cuentas</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Al completar el registro de forma satisfactoria, los clientes serán nivel 3.
                    </p>
                    <p className={classes.text}>
                        - En caso de no rendir información suficiente, se mantendrán en el nivel correspondiente de
                        acuerdo con la documentación efectivamente aportada.
                    </p>
                </Grid>
            </Grid>

            <Grid container className={classes.subGridTitle}>
                <Grid item xs={12}>
                    <Box className={classes.section}>
                        <p className={classes.subtitle}>
                            <strong>Derecho de terminación</strong>
                        </p>
                    </Box>

                    <Box className={classes.section}>
                        <p className={classes.text}>
                            Recuerda que dentro de los 30 (treinta) días naturales posteriores a que recibas esta
                            notificación podrás dar por terminado tu Contrato sin responsabilidad alguna, bajo las
                            condiciones pactadas previamente, debiendo cubrir, en su caso, los adeudos generados hasta
                            el término de tu cuenta, sin que se te cobre penalización alguna.
                        </p>
                    </Box>
                    <Box className={classes.section}>
                        <p className={classes.subtitle}>
                            <strong>Consulta del Contrato</strong>
                        </p>
                    </Box>
                    <Box className={classes.section}>
                        <p className={classes.text}>
                            Podrás revisar el texto íntegro del contrato y sus modificaciones:
                        </p>
                        <ul>
                            <li className={classes.text}>
                                En la sección de Legales de esta página y en tu aplicación.
                            </li>
                            <li className={classes.text}>
                                En el portal RECA de la CONDUSEF: <em>www.condusef.gob.mx</em>
                            </li>
                        </ul>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}

export default withStyles(styles)(ContractAdvice);
